import moment from "moment";

import { Scan } from "@types";
import { MINUTE } from "@utils";

import { ScanStatus } from "@pages/dashboard/types";
import { Repo } from "@pages/projects/types";

const SCAN_STARTING_WINDOW_MS = MINUTE * 5;
const SCAN_TIMEOUT_MS = MINUTE * 30;
/**
 * Returns the current "status" of the scan.
 * @param scan the scan to categorize
 * @return the current status of the scan as a ScanStatus
 */
export const getScanStatus = (repo: Repo, scan: Scan | null): ScanStatus => {
  const provisionTime = moment(repo.provisioned_at!).toDate();
  const now = new Date();

  if (scan === null) {
    if (now.getTime() - provisionTime.getTime() < SCAN_STARTING_WINDOW_MS) {
      return "starting";
    }
    return "never_started";
  } else if (scan.completed_at) {
    if (scan.exit_code === 0 || scan.exit_code === 1) {
      return "succeeded";
    } else {
      return "error";
    }
  } else if (scan.started_at) {
    const startedTime = moment(scan.started_at!).toDate();
    if (now.getTime() - startedTime.getTime() < SCAN_TIMEOUT_MS) {
      return "running";
    } else {
      return "never_finished";
    }
  } else {
    return "never_started";
  }
};
